import React from "react";
import Image from "gatsby-image";
import { ArticlePhotos } from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  return {
    date: "05.03.2020r",
    category: "sztuczna inteligencja, marketing, internet",
    title: "Sztuczna inteligencja i marketing",
    description: (
      <>
        Hasło „sztuczna inteligencja” wciąż może się kojarzyć z inteligentnymi
        robotami, które zagrażają istnieniu ludzkości - takimi, jakie znamy z
        filmów science fiction. Wielu nie zdaje sobie jednak sprawy, że AI już
        bardzo mocno wkroczyło do naszego życia i zupełnie nie przypomina
        fantastycznonaukowych wizji. W tym wpisie przyjrzymy się, w jaki sposób
        wykorzystywana jest sztuczna inteligencja w marketingu.
      </>
    ),
    seo:
      " Hasło „sztuczna inteligencja” wciąż może się kojarzyć z inteligentnymi robotami",
    slug: "/blog/sztuczna_inteligencja_i_marketing",
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "„Ok, Google” i SEO",
        text: (
          <>
            AI stoi za wszystkimi asystentami głosowymi, którzy zresztą zyskują
            coraz większą popularność na całym świecie - również w Polsce.
            Asystent Google, Siri, Alexa - to najpopularniejsze z nich, których
            nazwy zna niemalże każdy z nas. Sztuczna inteligencja, która za nimi
            stoi, analizuje pytania użytkowników i dopasowuje odpowiedź. Coraz
            bardziej zaawansowane algorytmy radzą sobie z coraz bardziej
            skomplikowanymi zapytaniami, a także są w stanie rozpoznać już nawet
            niewyraźną mowę. Asystent Google jest już również dostępny w języku
            polskim, który należy do jednych z najtrudniejszych na świecie.
            Jakie to ma znaczenie dla marketingu? Dwa słowa: wyszukiwanie
            głosowe.
          </>
        ),
      },
      second: {
        title: "",
        text: (
          <>
            Frazy wprowadzane w wyszukiwarce są łatwe. Wielu użytkowników
            internetu nauczyło się, że wpisując jak najprostsze zapytania,
            uzyskuje jak najbardziej trafne wyniki. Wyszukiwanie głosowe jednak
            odwraca ten tok myślenia. Do wirtualnego asystenta nie powiemy:
            „pizza Rzeszów”, tylko zapytamy: „gdzie zjem dobrą pizzę w
            Rzeszowie?”. To stawia nowe wyzwania przed specjalistami SEO i
            stanowi wielką szansę zwłaszcza dla firm działających stacjonarnie
            czy oferujących swoje usługi w internecie. Patrząc jednak z innej
            perspektywy, można zauważyć też ciemną stronę wirtualnych pomocników
            - stanowią one znaczące zagrożenie dla blogów. Asystenci głosowi
            wszak podają użytkownikom na tacy gotowe rozwiązania, niwelując
            wymóg ich wejścia na stronę i zasięgnięcia konkretnej informacji.
          </>
        ),
      },
      third: {
        title: "Porozmawiaj z robotem",
        text: (
          <>
            Chatboty, które zyskują na coraz większym znaczeniu, są również
            wspierane przez sztuczną inteligencję. Pracownicy idealni - dostępni
            24/7, zawsze gotowi precyzyjnie odpowiadać klientom lub przekazywać
            rozmowę odpowiednim ludziom. Wraz z rozwojem sztucznej inteligencji,
            chatboty zyskują na coraz większym znaczeniu. Ludzie nie lubią
            rozmawiać z automatami - a wysoko rozwinięta sztuczna inteligencja
            sprawia, że nierzadko już nawet nie jesteśmy pewni, czy po drugiej
            stronie faktycznie siedzi człowiek.
          </>
        ),
      },
      fourth: {
        title: "",
        text: (
          <>
            Klienci potrzebują informacji tu i teraz. Dla fizycznych pracowników
            jest to niemożliwe. Chatboty umożliwiają natychmiastową odpowiedź i
            są nieocenione zwłaszcza wtedy, gdy problem czy pytanie użytkownika
            są typowe. To niesie ze sobą kolejną zaletę AI - fizyczni pracownicy
            mogą zająć się bardziej skomplikowanymi problemami, nie tracąc czasu
            na te trywialne.
          </>
        ),
      },
      fifth: {
        title: "Nie mówi się „hejka” do starszej pani",
        text: (
          <>
            Chatoboty oparte na sztucznej inteligencji również świetnie wpisują
            się w zagadnienie personalizacji treści. Stanowi to jeden z
            ważniejszych marketingowych trendów - i nie jest to zaskakujące.
            Ludzie są różni, a umiejętność dopasowania treści sprzedażowych do
            ich upodobań i gustów jest jedną z podstaw marketingu w dzisiejszych
            czasach. Sztuczna inteligencja świetnie się do tego nadaje.
          </>
        ),
      },
      sixth: {
        title: "",
        text: (
          <>
            To algorytmy zajmują się analizą zainteresowań i profilowaniem
            klientów, segregując ich. Dzięki temu nie tylko łatwiej kierujemy
            reklamy, ale możemy przystosować komunikat do sposobu myślenia ich
            odbiorców. Ten sam produkt można przecież wypromować na kilka
            różnych sposobów - za każdym razem dopasowując wiadomość do
            charakteru adresata. Z prostej logiki wynika, że jest to znacznie
            skuteczniejsze niż próba ślepego zgadnięcia, jak trafić z przekazem
            do klientów.
          </>
        ),
      },
      seventh: {
        title: "",
        text: (
          <>
            To tylko trzy przykłady wykorzystania sztucznej inteligencji w
            marketingu. W praktyce wkrada się ona w każdą dziedzinę naszego
            życia, nie tylko w reklamie - i będzie ona zyskiwała na coraz
            większym znaczeniu. Bez względu na to, czy nam się to podoba, czy
            nie, AI to przyszłość, która dzieje się już dziś.
          </>
        ),
      },
    },
  };
};
